<template>
  <div class="card card-with-shadow border-0 h-100 employee-preview-card">
    <div class="card-body position-relative d-flex flex-column justify-content-between">
      <div v-if="showAction" class="dropdown options-dropdown position-absolute" style="z-index: 999">
        <button
          type="button"
          class="btn-option btn d-flex align-items-center justify-content-center"
          data-toggle="dropdown"
        >
          <app-icon name="more-horizontal" />
        </button>
        <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
          <a
            class="dropdown-item px-4 py-2"
            href="#"
            v-for="(action, index) in actions"
            :key="index"
            @click.prevent="callAction(action)"
          >
            {{ action.title }}
          </a>
        </div>
      </div>
      <div class="d-flex flex-column">
        <!-- <app-avatar
          :title="profile.name"
          avatar-class="avatars-w-60 mb-2 d-inline-block"
          :img="getImageUrl(profile)"
        /> -->

        <h5 class="mb-3 mt-3" style="font-size: 1.15rem; color: var(--job-title-color)">
          {{ profile.title }}
        </h5>
        <small class="mb-3">({{ profile.job_type }})</small>

        <p class="mb-3 font-size-90">{{ profile.description }}</p>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <p class="mb-3">
              {{ $t('start_date') + ': ' + profile.start_date }}
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <p class="mb-2">
              {{ $t('end_date') + ': ' + profile.end_date }}
            </p>
          </div>
        </div>

        <!-- <p class="mb-2">
          {{ $t("job_type") + ": " + profile.job_type }}
        </p> -->
        <!-- <div v-if="profile.status" class="my-3">
          <span
            :class="
              'badge badge-sm badge-pill badge-' + statusClass(profile.status)
            "
            >{{ profile.status }}</span
          >
        </div> -->
        <p v-if="profile.phone" class="mb-2">{{ profile.phone }}</p>
        <p v-if="profile.gender" class="mb-2">{{ $t(profile.gender) }}</p>
        <p v-if="profile.age" class="mb-2">
          {{ $t('age') + ': ' + profile.age }}
        </p>
      </div>
    </div>

    <job-view-modal v-if="JobModalActive" @close-modal="closeModal" v-bind:jobId="profile.id" />
  </div>

</template>

<script>
import AppFunction from '../../../../../../core/helpers/app/AppFunction';
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: 'JobCard',
  data() {
    return {
      JobModalActive: false,
      job: {},
    };
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    showAction: {
      type: Boolean,
      default: true
    },
    id: {
      required: true
    }
  },
  methods: {
    callAction(action) {
      // this.$emit("action-" + this.id, this.profile, action, true);
      // this.JobModalActive = true;
      let id = this.profile.id;

      if (action.title == this.$t("add_to_favorite")) {
          this.jobMarked(id);
      } else if (action.title == this.$t("view_job")) {
          this.JobModalActive = true;
      }
    },
    jobMarked(id) {
      this.job.id = id;
      axiosPost(actions.MARKED_JOB,this.job)
        .then((res) => {
          
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error.data.type);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getImageUrl(profile) {
      if (profile.profile_picture) {
        return AppFunction.getAppUrl(profile.profile_picture);
      }
      return AppFunction.getAppUrl('images/avatar-demo.jpg');
    },
    statusClass(status) {
      let ClassName = 'danger';
      if (status === 'active') ClassName = `success`;
      else if (status === 'invited') ClassName = `warning`;
      return ClassName;
    },
    closeModal() {
      this.JobModalActive = false;
    }
  }
};
</script>